import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { useQuery } from "react-query";
import { ResultMeasurementStatusComment } from "../../shared/interfaces/ResultMeasurementStatusComment";
import { Measurement } from "../../shared/interfaces/Result";

export function useResultMeasurementStatusComments(
  captureId: number,
  customerId: number,
  panel360AssetId: number,
  panelNo: string,
  measurement: Measurement,
  callbacks?: QueryCallbacks<ResultMeasurementStatusComment[]>,
) {
  const apiContext = useContext(ApiContext);
  return useQuery({
    queryKey: ["resultMeasurementStatusComments", captureId, customerId, panel360AssetId, panelNo, measurement],
    queryFn: async () => {
      if (captureId)
        return await apiContext.resultsApis.getResultMeasurementStatusComments(
          captureId,
          customerId,
          panel360AssetId,
          panelNo,
          measurement,
        );
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
